import React from 'react';
import { Grid, Card, CardContent, } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import Logo from '../../images/LOGO_CSC_HORINZONTAL.png';
import LogoZabug from '../../images/logoZabug.jpeg';
import { styles } from './styles';

const LoginContainer = (props) => {
    const classes = styles();

    return (
        <div className={classes.backgroundLogin}>
            <Grid container className={classes.policy}  alignItems="center">
                <Grid item  xs={12} md={4} className={classes.containerFormLogin} >
                <Card elevation={0}>
                    <CardContent className = { classes.classCardLogos}>
                    <Grid container space = {2} className = { classes.classContainerLogos } >
                        <Grid item xs={7}>
                            <img 
                                src = {Logo} 
                                width = "90%" 
                                height = "100%" 
                                alt = "" 
                                className = { classes.borderImageLogo }
                            />
                        </Grid>
                        <Grid item xs={5}>
                            <img 
                                src = { LogoZabug } 
                                width = "60%" 
                                height = "70%" 
                                alt = "" 
                            />
                        </Grid>
                    </Grid>
                        <Grid item  xs = {12} md = {12} style = {{ paddingRight: '25px', marginLeft: 10 }}>
                            {props.children}
                        </Grid>
                    </CardContent>
                </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default withRouter(LoginContainer);
